import React, { Component } from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";

let easing = [0.6, -0.05, 0.01, 0.99];
const animate = {
  opacity: 1,
  y: 0,
  transition: {
    duration: 0.6,
    ease: easing,
    delay: 0.16,
  },
};

const motionify = (to_render) => {
    return (
        <Box
            component={motion.div}
            sx={{ minHeight: 0, flex: 1 }}
            animate={{
                transition: {
                staggerChildren: 0.55,
                },
            }}
            >
            <Box
                sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                }}
                component={motion.div}
                initial={{ opacity: 0, y: 40 }}
                animate={animate}
            >
                {to_render}
            </Box>
        </Box>
    )
}

export default motionify
